import { SUSTAINABILITY_METRICS } from "../data/sustainabilityMetrics";
import ImpactStatCard from "./ImpactStatCard";

/** Renders a "coming soon" panel while SUSTAINABILITY_METRICS is null — see that file. */
export default function CarbonImpactDashboard() {
  if (!SUSTAINABILITY_METRICS) {
    return (
      <div className="mx-auto max-w-md rounded-2xl bg-foam-100 p-8 text-center">
        <p className="text-sm text-ocean-800/60">
          Our aggregate carbon-impact dashboard will appear here once our anonymised metrics pipeline is
          live.
        </p>
      </div>
    );
  }

  const metrics = SUSTAINABILITY_METRICS;

  return (
    <div>
      <div className="grid gap-6 sm:grid-cols-3">
        <ImpactStatCard stat={metrics.carbonSaved} />
        <ImpactStatCard stat={metrics.lowCarbonOrders} />
        <ImpactStatCard stat={metrics.ecoPackagingAdoption} />
      </div>
      <p className="mt-4 text-center text-xs text-ocean-800/50">
        Figures are aggregated and anonymised — no individual order or customer data. Last updated{" "}
        {metrics.asOf}.
      </p>
    </div>
  );
}
